export default __webpack_public_path__ + "static/media/1-Contract-Signing.d273f92e.jpg";